import { rfqQuoteDetailsHeaderStyles as styles } from "@bevco/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import { css } from "styled-components";

styles.title = {
    variant: "h2",
    as: "h1",
};

styles.placeOrderButton = {
    variant: "tertiary",
};

styles.requoteButton = {
    variant: "tertiary",
};

styles.editQuoteButton = {
    variant: "tertiary",
};

styles.cancelQuoteButton = {
    variant: "tertiary",
};

styles.placeOrderButton = {
    ...styles.placeOrderButton,

    css: css`
        margin-left: 20px;
    `,
};

styles.requoteButton = {
    ...styles.requoteButton,

    css: css`
        margin-left: 20px;
    `,
};

styles.editQuoteButton = {
    ...styles.editQuoteButton,

    css: css`
        margin-left: 20px;
    `,
};

styles.cancelQuoteButton = {
    ...styles.cancelQuoteButton,

    css: css`
        margin-left: 20px;
    `,
};

styles.printButton = {
    ...styles.printButton,

    css: css`
        margin-left: 20px;
    `,
};

styles.deleteQuoteButton = {
    ...styles.deleteQuoteButton,

    css: css`
        margin-left: 20px;
    `,
};

styles.submitQuoteButton = {
    ...styles.submitQuoteButton,

    css: css`
        margin-left: 20px;
    `,
};

styles.declineQuoteButton = {
    ...styles.declineQuoteButton,

    css: css`
        margin-left: 20px;
    `,
};

styles.acceptQuoteButton = {
    ...styles.acceptQuoteButton,

    css: css`
        margin-left: 20px;
    `,
};
